import type { FieldStateMap } from '@/utils/field-state'

export const portfolioDataTabs = ['overview', 'purchase', 'building', 'rent', 'modernization'] as const

export type PortfolioDataTab = (typeof portfolioDataTabs)[number]

export type PortfolioTab = PortfolioDataTab | 'documents'

export const portfolioTabs: readonly PortfolioTab[] = [...portfolioDataTabs, 'documents']

/**
 * Where a required estate object field is edited. Lets other pages send the
 * user straight to the tab that holds the value they point at.
 */
const tabPerField: Record<string, PortfolioDataTab> = {
  estate_object_type: 'overview',
  owner_id: 'overview',
  street: 'overview',
  house_number: 'overview',
  zip_code: 'overview',
  city: 'overview',
  purchase_price: 'purchase',
  land_register_charge: 'purchase',
  broker_commission: 'purchase',
  notary_land_registry_fees: 'purchase',
  equity: 'purchase',
  number_of_floors: 'building',
  number_of_units: 'building',
  living_space_size: 'rent',
  business_space_size: 'rent',
  actual_rent_living: 'rent',
  actual_rent_business: 'rent',
}

export const portfolioTabForField = (field: string | null): PortfolioDataTab =>
  (field === null ? undefined : tabPerField[field]) ?? 'overview'

/**
 * The tab badges count what is still open in the section the user would edit it in.
 * Which fields are required is the server's answer; where they live is this file's.
 */
export const missingPerPortfolioTab = (fieldStates: FieldStateMap): Record<PortfolioDataTab, number> => {
  const counts = Object.fromEntries(portfolioDataTabs.map((tab) => [tab, 0])) as Record<PortfolioDataTab, number>

  Object.values(fieldStates)
    .filter((field) => field.state === 'missing')
    .forEach((field) => {
      counts[portfolioTabForField(field.key)] += 1
    })

  return counts
}
